import { Text, View } from '@react-pdf/renderer';
import { styles } from '../style/pdfStyles';
import { PdfKeyValueTable } from './PdfKeyValueTable';
import { PUBLIC_PROFILE_KEYS } from '../utils/publicFields';
import { findCompanyInfoModule, getFieldValue, normalizeValue } from '../utils/normalize';

interface PdfIntroProps {
  publicInfos?: {
    paragraphs?: Record<string, string>;
  };
  modules: Array<{ name: string; type: string; content?: Record<string, string> }>;
}

export const PdfIntro = ({ publicInfos, modules }: PdfIntroProps) => {
  const companyModule = findCompanyInfoModule(modules);
  const content = (companyModule as { content?: Record<string, string> })?.content || {};

  const profileRows = PUBLIC_PROFILE_KEYS.map((label) => {
    const value = getFieldValue(content, label);
    return value ? { label, value: normalizeValue(value) } : null;
  }).filter((row): row is { label: string; value: string } => Boolean(row));

  const paragraphEntries = Object.entries(publicInfos?.paragraphs || {});

  return (
    <View>
      <Text style={styles.sectionTitle}>Introduzione</Text>

      <View style={[styles.box, styles.block]}>
        <Text style={styles.subtitle}>Profilo struttura</Text>
        <PdfKeyValueTable
          rows={profileRows}
          emptyMessage="Nessun dato pubblico disponibile."
        />
      </View>

      <View>
        {paragraphEntries.length === 0 ? (
          <Text style={[styles.text, styles.mutedText]}>
            Nessun contenuto disponibile.
          </Text>
        ) : (
          paragraphEntries.map(([title, value]) => (
            <View key={title} style={styles.block}>
              <Text style={styles.subtitle}>{title}</Text>
              <Text style={styles.text}>{normalizeValue(value)}</Text>
            </View>
          ))
        )}
      </View>
    </View>
  );
};
